var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoriqueicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115 115.1",
    style: {
      enableBackground: "new 0 0 115 115.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,20.9c20.4,0,36.8,16.5,36.7,36.9c-0.1,20.1-16.6,36.5-36.8,36.5c-20.3,0-36.6-16.5-36.6-36.9 C20.9,37.3,37.4,20.8,57.5,20.9z M53.4,47.3c0,3.3,0,6.5,0,9.8c0,1.8,0.7,3.1,2.2,4.1c3.8,2.5,7.6,5.1,11.4,7.6 c2.3,1.5,4.7,1.2,6-0.8c1.3-2,0.8-4.4-1.5-5.9c-3-2-5.9-4-8.9-5.9c-0.8-0.5-1.1-1-1.1-2c0.1-5.5,0-11,0-16.6c0-2.6-1.7-4.4-4.1-4.4 c-2.4,0-4.1,1.8-4.1,4.4C53.4,40.8,53.4,44,53.4,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6,16.8c1.1,0,1.8,0,2.5,0c2.3,0.1,4,1.9,4,4.1c0,2.2-1.7,4-4,4c-4.2,0.1-8.3,0.1-12.5,0c-2.2,0-3.9-1.8-3.9-4 c0-4.1,0-8.1,0-12.2c0-2.3,1.8-4.1,4-4.1c2.3,0,4.1,1.7,4.1,4.1c0,0.6,0,1.2,0,1.9c0.4-0.2,0.7-0.3,0.9-0.5 c33.9-22.7,80.3-3.2,87.7,37c5.7,30.7-14.1,60.1-44.8,66.4c-30,6.2-60.1-13.2-66.7-43C1.1,66.4,0.8,62.2,0.5,58 c-0.2-2.6,1.6-4.5,3.9-4.5c2.4-0.1,4.1,1.8,4.2,4.5c0.4,22.5,15,41.3,36.5,47c26.6,7.1,54.2-9.6,60.2-36.5 c5.9-26.1-10.1-52-36.1-58.4C56,6.8,43.5,8.9,31.8,16C31.5,16.2,31.2,16.4,30.6,16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoriqueicon2);
export default __webpack_public_path__ + "static/media/historique icon2.803220768f72fb80ce015cf92df178e4.svg";
export { ForwardRef as ReactComponent };